import { useState, useEffect } from 'react';

const slides = [
  {
    src: "https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/ec68ea955e062fef440c79c678ef5b3d.png",
    label: "Special Event",
  },
  {
    src: "https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/523e6c46f805c333bc825c7244d01032.png",
    label: "Outdoor Event",
  },
  {
    src: "https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/8fdc1efbfcbb34e8bbe5d736d081ff25.png",
    label: "Gala Event",
  },
  {
    src: "https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/d3a7025cd53eca88eb28f042a52ba3cd.png",
    label: "Japanese Culture",
  },
];

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);
  const [textIndex, setTextIndex] = useState(0);
  const [textVisible, setTextVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setFade(false);
      setTextVisible(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
        setTextIndex((prev) => (prev + 1) % 2);
        setFade(true);
        setTextVisible(true);
      }, 1200);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index: number) => {
    if (index === current) return;
    setFade(false);
    setTimeout(() => {
      setCurrent(index);
      setFade(true);
    }, 1200);
  };

  const textStyle = {
    fontSize: 'clamp(1.8rem, 5.8vw, 4.1rem)',
    fontFamily: '"Noto Sans JP", "Helvetica Neue", Arial, sans-serif',
    fontWeight: 300,
    color: 'rgb(26, 26, 26)',
    letterSpacing: '0.02em',
    opacity: textVisible ? 1 : 0,
    transition: 'opacity 1.2s ease-in-out',
  };

  const textStyleJa = {
    fontSize: 'clamp(1.8rem, 5.5vw, 3.8rem)',
    fontFamily: '"Noto Sans JP", "Helvetica Neue", Arial, sans-serif',
    fontWeight: 300,
    color: 'rgb(26, 26, 26)',
    letterSpacing: '0.02em',
    opacity: textVisible ? 1 : 0,
    transition: 'opacity 1.2s ease-in-out',
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" style={{ backgroundColor: '#FAF7F2' }}>
      <div className="absolute inset-0">
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #F5F0E8 0%, #FAF7F2 50%, #F0EBE0 100%)' }}></div>
        <div className="absolute top-0 right-0 w-1/2 h-1/2 rounded-full blur-3xl" style={{ background: 'rgba(240, 235, 224, 0.5)' }}></div>
        <div className="absolute bottom-0 left-0 w-1/3 h-1/3 rounded-full blur-3xl" style={{ background: 'rgba(245, 240, 232, 0.5)' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center min-h-screen py-32">
          <div className="space-y-6 md:space-y-10">
            <div className="inline-flex items-start" style={{ minHeight: 'clamp(8rem, 16vw, 12rem)' }}>
              <div style={{ position: 'relative', minWidth: 0 }}>
                {textIndex === 0 ? (
                  <div
                    className="tracking-[0.02em] uppercase font-light"
                    style={{ ...textStyle, lineHeight: 1.2 }}
                  >
                    <span style={{ display: 'block' }}>CREATING</span>
                    <span style={{ display: 'block' }}>a unique</span>
                    <span style={{ display: 'block', color: 'rgb(200, 16, 46)' }}>experience</span>
                  </div>
                ) : (
                  <div
                    className="tracking-[0.02em] font-light"
                    style={{ ...textStyleJa, lineHeight: 1.2 }}
                  >
                    <span style={{ display: 'block' }}>唯一無二の</span>
                    <span style={{ display: 'block' }}><span style={{ color: 'rgb(200, 16, 46)' }}>体験</span>を</span>
                    <span style={{ display: 'block' }}>創造する</span>
                  </div>
                )}
              </div>
            </div>

            <p className="text-xs lg:text-lg font-light text-gray-600 leading-relaxed max-w-md">
              富裕層・企業向けに特化したオーダーメイドイベントをプロデュース。ブランドの格にふさわしい、少人数・高密度のイベントを企画・運営いたします。
            </p>

            <div className="flex items-center space-x-8 pt-2">
              <button
                className="group relative px-6 py-3 md:px-10 md:py-5 cursor-pointer whitespace-nowrap overflow-hidden"
                onClick={() => {
                  const el = document.getElementById('contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <span className="relative z-10 flex items-center space-x-2 md:space-x-3 text-black group-hover:text-white transition-colors duration-300">
                  <span className="text-xs md:text-sm tracking-wide">相談する</span>
                  <i className="ri-arrow-right-line text-base md:text-lg transition-transform group-hover:translate-x-2 duration-300"></i>
                </span>
                <div className="absolute inset-0 border border-black"></div>
                <div
                  className="absolute inset-0 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"
                  style={{ backgroundColor: 'rgb(200, 16, 46)' }}
                ></div>
              </button>
            </div>
          </div>

          <div className="relative h-[500px] hidden lg:block">
            <div className="absolute inset-0 overflow-hidden rounded-lg">
              <img
                key={current}
                src={slides[current].src}
                alt={slides[current].label}
                className="w-full h-full object-cover object-top"
                style={{
                  opacity: fade ? 1 : 0,
                  transition: 'opacity 1.2s ease-in-out',
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>

              <div
                className="absolute bottom-6 left-6"
                style={{
                  opacity: fade ? 1 : 0,
                  transition: 'opacity 1.2s ease-in-out',
                }}
              >
                <span className="text-white text-xs tracking-[0.25em] uppercase font-light bg-black/30 px-3 py-1 rounded-sm">
                  {slides[current].label}
                </span>
              </div>
            </div>

            <div className="absolute bottom-6 right-6 flex items-center space-x-2 z-10">
              {slides.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className="cursor-pointer transition-all duration-300"
                  style={{
                    width: i === current ? '24px' : '8px',
                    height: '8px',
                    borderRadius: i === current ? '4px' : '50%',
                    backgroundColor: i === current ? 'white' : 'rgba(255,255,255,0.5)',
                    border: 'none',
                    padding: 0,
                  }}
                />
              ))}
            </div>

            <div className="absolute top-20 right-20 w-3 h-3 bg-black rounded-full animate-pulse"></div>
            <div className="absolute bottom-32 left-16 w-2 h-2 bg-gray-400 rounded-full"></div>
            <div className="absolute top-1/3 left-8 w-1 h-24 bg-gray-300 opacity-60"></div>
            <div className="absolute bottom-1/4 right-12 w-16 h-1 bg-gray-300 opacity-60"></div>
            <div className="absolute top-8 left-8 w-32 h-32 border border-gray-200 opacity-30"></div>
            <div className="absolute bottom-16 right-16 w-24 h-24 border border-gray-300 opacity-40 rotate-45"></div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2">
        <div className="flex flex-col items-center text-gray-400">
          <div className="w-px h-16 bg-gray-300 animate-pulse"></div>
          <span className="text-[10px] tracking-[0.2em] mt-4 uppercase">Scroll</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
